module.exports = __webpack_public_path__ + "img/man_1@2x.ba658183.png";